module.exports = __webpack_public_path__ + "69053787abb87053302e9b5163281413.png";